//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import payPublic from '@/javascript/payPublic'
    import util from '@/javascript/util'
    
    export default {
        mounted() {
            document.title = Number(this.orderInfo.payMoney) === 0 || this.finish ? '提示' : '支付订单'
            if(this.THE_CLIENT){
                this.payList = ['微信', '支付宝']
            }else{
                this.payList = ['微信']
            }
            this.minHeight = document.documentElement.clientHeight
            if (util.isWeiXin()) {
                const shareData = typeof (shareData) === 'undefined' ? {
                    title: Number(this.orderInfo.payMoney) === 0 || this.finish ? '提示' : '支付订单',
                    desc: this.SHARE_TEXT,
                    imgUrl: this.SHARE_IMG,
                    link: window.location.href.split('#')[0]
                } : shareData;
                this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href.split('#')[0]) + '&appId=' + this.WX_APPID).then((response) => {
                    util.initWxConfig(response.data.data, shareData)
                })
            }
            this.getTabData()
        },
        data() {
            return {
                minHeight: 0,
                payList: [],
                curPay: 0,
                orderInfo: this.$route.query,
                finish: false,
                orderDetails: ''
            }
        },
        methods: {
            getTabData() {
                const _this = this
                if (payPublic.isClient()) {
                    payPublic.toToken(function () {
                        const noLogin = localStorage.getItem('noLogin')
                        if (!noLogin) {
                            const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                            _this.publicWay(userInfo)
                        } else {
                            payPublic.goBack()
                        }
                    })
                } else {
                    payPublic.loginCheck(function () {
                        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                        _this.publicWay(userInfo)
                    })
                }
            },
             /**
             * @msg: 微信统一下单
             * @param {*}
             * @return {*}
             */
            PlaceOrder(userInfo) {
                let wxinfo = JSON.parse(localStorage.getItem("wxUserInfo"))
                if (wxinfo) {
                    let amount = this.orderInfo.payMoney * 100
                    let remark = this.orderInfo.body || '该商品没有描述' 
                    this.$http.get("/api/wtcp-ecrm/wxpay/v3/jsApiPay?openId=" + wxinfo.openid + '&access_token=' + userInfo.access_token + '&orderCode=' + this.orderInfo.orderCode + '&amount=' + amount + '&description=' + encodeURIComponent(remark)).then(res => {
                        if (res.data.data) {
                            this.weiXinPay(res.data.data)
                        }
                    })
                }
            },
            /**
             * @msg: 微信支付
             * @param {*}
             * @return {*}
             */
            weiXinPay(data) {
                const _this = this
                window.wx.chooseWXPay({  //此方法应放在调用后台统一下单接口成功后回调里面，接口返回  timeStamp，nonceStr，package，paySign等参数
                    timestamp: data.timeStamp, 
                    nonceStr: data.nonceStr, 
                    package: data.package,
                    signType: data.signType, 
                    paySign: data.paySign, 
                    appId: data.appId,  //此参数可不用
                    success: (r) => {
                        // 支付成功后的回调函数  
                        //支付成功  
                    　　if (r.errMsg == "chooseWXPay:ok") { 
                            // 拼团支付
                            if (_this.orderInfo.mainOrderId && _this.orderInfo.orderIds) {
                                _this.$router.push('/groupDetail/' + _this.orderInfo.mainOrderId + '/' +  _this.orderInfo.orderIds[0])
                                return
                            }
                            _this.finish = true
                　　　　} else {  
                            _this.$router.go(-1) 
                    　　}  
                　　},
                　　cancel: (r) => {  
                        //支付取消  
                    }  
                });
            },

            publicWay(info) {
                this.$http.get('/api/wtcp-ecrm/comOrderClient/getOrderByMainCode?mainOrderCode=' + this.orderInfo.orderCode + '&access_token=' + info.access_token).then(res => {
                    this.orderDetails = res.data.data
                })
            },
            changePay(index){
                this.curPay = index
            },
            goPay(){
                const _this = this
                if (util.isWeiXin() && _this.curPay == 0) {
                    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                    _this.PlaceOrder(userInfo)
                } else {
                    const params = {
                        "type": _this.curPay+1, //支付方式：1、微信， 2、支付宝
                        "orderList": _this.orderInfo
                    }
        
                    _this.$bridge.callHandler("jspay", params, (res) => {
                        // Android
                        if(typeof(res) == "string"){
                            const result = JSON.parse(res)
    
                            if(result.success == "success"){
                                // 拼团支付
                                if (_this.orderInfo.mainOrderId && _this.orderInfo.orderIds) {
                                    _this.$router.push('/groupDetail/' + _this.orderInfo.mainOrderId + '/' +  _this.orderInfo.orderIds[0])
                                    return
                                }
                                _this.finish = true
                            }else{
                                _this.$router.go(-1)
                            }
                        }else{
                            // ios
                            if(res.success == "success"){
                                // 拼团支付
                                if (_this.orderInfo.mainOrderId && _this.orderInfo.orderIds) {
                                    _this.$router.push('/groupDetail/' + _this.orderInfo.mainOrderId + '/' +  _this.orderInfo.orderIds[0])
                                    return
                                }
                                _this.finish = true
                            }else{
                                _this.$router.go(-1)
                            }
                        }
                    })
                }

            },
            finished(){
                // if(payPublic.isClient()){
                //     payPublic.goBack()
                // }else{
                //     this.$router.go(-1)
                // }
                if(this.$store.state.carlistFrom){
                    this.$router.replace(this.$store.state.carlistFrom)
                }else{
                    this.$router.go(-1)
                }
            }
        }
    }
